<template>
  <div class="i-detail-similar" v-if="followers>=2000">
    <div class="i-detail-similar-title">
      <div>{{ title_name }}の分布</div>
      <div class="flex-space"></div>
      <div class="i-detail-analysis-subtitle">
        <div class="egr-chart-name">{{ name }}</div>
        と同程度の
        <span v-if="sns_type == 'instagram'">フォロワー数</span>
        <span v-if="sns_type == 'youtube'">チャンネル登録者数</span>
        ({{ avg_data.follower_min | addComma }}~{{ avg_data.follower_max | addComma }})のインフルエンサーを対象とした分布図です
      </div>
    </div>
    <div class="i-detail-similar-wrap" id="engagement">
      <div class="egr-chart-wrap">
        <div class="egr-chart-x">
          <div class="egr-chart-x-label"></div>
          <div class="egr-chart-x-label"></div>
          <div v-for="(data, index) in avg_data.data" :key="index" class="egr-chart-x-label">
            {{ data.label }}
            <div v-if="data.target" class="egr-target-image-wrap pointer" @mouseover="user_mouseover = true" @mouseleave="user_mouseover = false">
              <el-image class="egr-target-image" :src="avg_data.profile_picture_url">
                <div slot="error" class="data-table-profile-noimg"></div>
              </el-image>
            </div>
          </div>
          <div class="egr-chart-x-label" style="color:#ccc; font-size:10px">{{subtitle_name}}</div>
        </div>
        <div class="egr-chart-y">
          <div class="egr-chart-y-label-wrap label">
            全体に対する割合
          </div>
          <div class="egr-chart-y-label-wrap">
            <div class="egr-chart-y-label">10%</div>
            <div class="egr-chart-y-label">20%</div>
            <div class="egr-chart-y-label">30%</div>
            <div class="egr-chart-y-label">40%</div>
          </div>
          <div class="egr-chart-y-bar-wrap" v-for="(data, index) in avg_data.data" :key="index" @mouseover="mouseoverHandler(index, data.median)" @mouseleave="mouseleaveHandler()">
            <div class="egr-chart-y-bar" :style="'width:' + data.width + '%'" :class="data.target ? 'target' : ''"></div>
            <div class="egr-chart-y-value" :class="mouseover == index ? '' : 'transparent'">{{ data.percent }}%</div>
            <div class="egr-chart-y-bar-median" v-if="data.median">
              <span class="egr-chart-y-bar-median-word">中央値</span>
            </div>
          </div>
          <div class="egr-chart-y-bar"></div>
        </div>
        <div class="egr-chart-comparison-wrap">
          <div class="egr-chart-comparison" :class="median_mouseover ? 'mouseover' : ''">
            <div>{{ title_name }} 中央値</div>
            <div class="flex-space"></div>
            <div class="egr-chart-comparison-num">{{ avg_data.median }}</div>
            <div>%</div>
          </div>
          <div class="egr-chart-comparison" :class="user_mouseover ? 'mouseover' : ''">
            <div class="egr-chart-comparison-name">
              <div class="egr-chart-name">{{ name }}</div>
              <div>の{{ title_name }}</div>
            </div>
            <div class="flex-space"></div>
            <div class="egr-chart-comparison-num">{{ own_data }}</div>
            <div>%</div>
          </div>
          <div class="egr-chart-comparison" :class="user_mouseover ? 'mouseover' : ''">
            <div class="egr-chart-comparison-name">
              <div class="egr-chart-name">{{ name }}</div>
              のポジション
              <el-tooltip>
                <div slot="content">
                  {{ name }}と同程度の<span v-if="sns_type == 'instagram'">フォロワー数</span
                  ><span v-if="sns_type == 'youtube'">チャンネル登録者数</span>のインフルエンサー中で、<br />上位何パーセントに位置していているかを示しています。
                </div>
                <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px;" />
              </el-tooltip>
            </div>
            <div class="flex-space"></div>
            <div style="margin:0 -7px 0 10px">上位</div>
            <div class="egr-chart-comparison-num">{{ avg_data.top }}</div>
            <div>%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "distributionChart",
  props: ["avg_data", "own_data", "name", "type", "sns_type", "followers"],
  components: {
  },
  data() {
    return {
      mouseover: -1,
      median_mouseover: false,
      user_mouseover: false,
    };
  },
  computed: {
    title_name() {
      if (this.type == "egr") {
        return "エンゲージメント率";
      } else if (this.type == "vr") {
        return "視聴率";
      } else if (this.type == "lr") {
        return "高評価率";
      } else {
        return "";
      }
    },
    subtitle_name() {
      if (this.type == "egr") {
        return "EGR";
      } else if (this.type == "vr") {
        return "視聴率";
      } else if (this.type == "lr") {
        return "高評価率";
      } else {
        return "";
      }
    },
  },
  mounted() {},
  methods: {
    mouseoverHandler(index, median) {
      this.mouseover = index;
      if (median) this.median_mouseover = true;
    },
    mouseleaveHandler() {
      this.mouseover = -1;
      this.median_mouseover = false;
    },
  },
  filters: {
    localString(val) {
      return val.toLocaleString();
    },
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    // totalPercent(index){
    //   let percent = 0.0
    //   let length = this.egr_data.data.length
    //   for (let i = length; i >= (length - index); i--) {
    //     percent +=  this.egr_data.data[i].percent
    //   }
    //   return percent
    // }
  },
  watch: {},
};
</script>
